import React from 'react';

const MainText = () => {
  return (
    <div className='neu-card main-text'>
      <ul>
        <li>1) Select a Pose (Asana) from the list on left side</li>
        <li>2) Click 'Let's Begin' button below</li>
        <li>
          3) Adjust your position within 10 seconds. (The timer on right runs
          for 10 seconds)
        </li>
        <li>
          4) Keep your face towards the camera and the camera should have full
          view including legs
        </li>
        <li>
          5) Perform the selected pose for 10 seconds (The timer again runs for
          10 seconds but there is a slight delay when it runs for the first
          time)
        </li>
        <li>6) The better you perform the pose, more the score you get</li>
        <li>7) Try to beat your best score!</li>
      </ul>
    </div>
  );
};

export default MainText;
